import { useState } from 'react';
import styled from 'styled-components';
import { apiErrorText, useGetFieldPhotosQuery, useGetFieldSiteMembersQuery } from '@shared/api';
import { fmtFieldDate, photoCategoryLabel, photoIntegrityBadges } from '@entities/field';
import { reportAuthorLabel } from '@entities/field/tituls';
import { Badge } from '@shared/ui/Badge';
import { Button } from '@shared/ui/Button';
import { FieldPhotoThumb } from './FieldPhotoThumb';
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
`;
const Row = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin: 12px 0;
`;
const Meta = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
export function ReportPhotos({ siteId, reportId }: { siteId: string; reportId: string }) {
  const [offset, setOffset] = useState(0);
  const photosQ = useGetFieldPhotosQuery({ siteId, report_id: reportId, limit: 12, offset });
  const membersQ = useGetFieldSiteMembersQuery(siteId);
  const photos = photosQ.currentData?.photos ?? [];
  return (
    <section>
      <h3>Фото этого рапорта</h3>
      {photosQ.isFetching && <Meta>Загрузка фотографий…</Meta>}
      {photosQ.isError && (
        <p role="alert">
          {apiErrorText(photosQ.error, 'Не удалось загрузить фотографии рапорта.')}
        </p>
      )}
      {!photosQ.isFetching && !photosQ.isError && photos.length === 0 && (
        <Meta>Фотографии к этому рапорту не приложены.</Meta>
      )}
      <Grid>
        {photos.map((p) => (
          <div key={p.id}>
            <FieldPhotoThumb photoId={p.id} alt={photoCategoryLabel(p.category)} />
            <Meta>
              {photoCategoryLabel(p.category)} · {fmtFieldDate(p.taken_at ?? p.server_received_at)}
              <br />
              Автор: {reportAuthorLabel(p, membersQ.currentData?.members ?? [])}
              {p.source === 'gallery' && <> · из галереи</>}
            </Meta>
            {photoIntegrityBadges(p).map((b) => (
              <Badge key={b.label} $tone={b.tone} title={b.hint}>
                {b.label}
              </Badge>
            ))}
          </div>
        ))}
      </Grid>
      <Row>
        <Button
          $size="sm"
          $variant="ghost"
          disabled={offset === 0 || photosQ.isFetching}
          onClick={() => setOffset((n) => Math.max(0, n - 12))}
        >
          Назад
        </Button>
        <span>Всего: {photosQ.currentData?.total ?? 0}</span>
        <Button
          $size="sm"
          $variant="ghost"
          disabled={photosQ.isFetching || offset + 12 >= (photosQ.currentData?.total ?? 0)}
          onClick={() => setOffset((n) => n + 12)}
        >
          Далее
        </Button>
      </Row>
    </section>
  );
}
